import React from "react";

export const en = {
  body: (
    <div>
      <h3>Expert system for classifying Czech vegetation (CzechVeg-ESy)</h3>	
      <div>
        Expert system for automatic classification of vegetation plots (relevés) from the Czech Republic was developed within the project Vegetation of the Czech Republic (<a href="https://botzool-vegetation.netlify.com/vegetationCR">Chytrý 2007–2013</a>) and is further improved after the completion of this project. This expert system contains formal definitions of all phytosociological vegetation types (syntaxa) differentiated in the Czech Republic, which are used to classify individual vegetation plots. The classification is performed using the <a href="https://botzool-vegetation.netlify.com/juice">JUICE</a> program. The associated data files, documentation and instructions for use are available in the Zenodo repository: <a href="http://doi.org/10.5281/zenodo.3605561">http://doi.org/10.5281/zenodo.3605561</a>.
      </div>
    </div>
  )
};

export const cz = {
  body: (
    <div>
      <h3>Expertní systém pro klasifikaci vegetace České republiky (CzechVeg-ESy)</h3>
      <div>
        Expertní systém pro automatickou klasifikaci fytocenologických snímků z České republiky byl vyvinut v rámci projektu Vegetace České republiky (<a href="https://botzool-vegetation.netlify.com/vegetationCR">Chytrý 2007–2013</a>) a je dále zdokonalován i po ukončení tohoto projektu. Tento expertní systém obsahuje formální definice všech vegetačních typů (syntaxonů) rozlišovaných na území ČR, pomocí nichž je schopen klasifikovat jednotlivé fytocenologické snímky. Klasifikace se provádí pomocí programu <a href="https://botzool-vegetation.netlify.com/juice">JUICE</a>. Příslušné datové soubory v různých verzích, dokumentace k nim a návod k použití jsou umístěny v úložišti Zenodo: <a href="http://doi.org/10.5281/zenodo.3605561">http://doi.org/10.5281/zenodo.3605561</a>.
      </div>
    </div>
  )
};
